import { render } from "./RiepilogoRichieste.vue?vue&type=template&id=0e3aa187&scoped=true&ts=true"
import script from "./RiepilogoRichieste.vue?vue&type=script&lang=ts"
export * from "./RiepilogoRichieste.vue?vue&type=script&lang=ts"

import "./RiepilogoRichieste.vue?vue&type=style&index=0&id=0e3aa187&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_jecko_1764366014063414604/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3aa187"]])

export default __exports__